import styled from "styled-components"

import SVGIcon from "../SVGIcon"

export default function AnimatedWindowHeader({ onBack, title }) {
  return (
    <HeaderBlock>
      <LeftBlock>
        <BackIconBlock onClick={onBack}>
          <SVGIcon name="arrow" />
        </BackIconBlock>
      </LeftBlock>
      <TitleBlock>
        <Title>{title}</Title>
      </TitleBlock>
      <RightBlock>
        {/* <BackIconBlock onClick={onBack}>
          <SVGIcon name="close" />
        </BackIconBlock> */}
      </RightBlock>
    </HeaderBlock>
  )
}

const HeaderBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: calc(100vw * (51 / 375));
  max-height: calc(100vw * (51 / 375));
  padding: 0 calc(100vw * (17 / 375));
`

const LeftBlock = styled.div`
  display: flex;
  flex: 20%;
  overflow-x: hidden;
`

const RightBlock = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex: 20%;
  overflow-x: hidden;
`

const BackIconBlock = styled.div`
  width: calc(100vw * (10 / 375));
  height: calc(100vw * (16 / 375));
  cursor: pointer;

  svg {
    transform: rotate(180deg);
    color: #4e4e4e;
  }
`

const TitleBlock = styled.div`
  width: calc(100vw * (150 / 375));
  flex: 60%;
`

const Title = styled.h1`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (19 / 375));
  text-align: center;
`
